import React from 'react';
import CarvanaHeader from '@carvana/header';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import '@carvana/header/styles.css'

export default function Header() {
  return (
    <MfeReactComponent
      component="default"
      module="HeaderModule"
      loading={<CarvanaHeader />}
    />
  );
}
